/**
 * Calculate the width of a text in pixels given a font
 * @param text The text to calculate the width of
 * @param font The font to use, e.g. "12px sans-serif"
 * @returns The width of the text in pixels
 */
export function getTextWidth(text: string, font: string): number {
  // @ts-ignore - save canvas element on function for performance
  const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement('canvas'))
  const context = canvas.getContext('2d')
  context.font = font
  const metrics = context.measureText(text)
  return metrics.width
}
